var exports = {
  "kL": "xaf9ae18d--3a8d9a--container",
  "M": "xaf9ae18d--3a8d9a--horizontal-margin",
  "su": "xaf9ae18d--3a8d9a--icon-wrapper",
  "vk": "xaf9ae18d--3a8d9a--clickable",
};

module.exports = exports;
